import { render, staticRenderFns } from "./ReaderLayout.vue?vue&type=template&id=6a81cec6&"
import script from "./ReaderLayout.vue?vue&type=script&lang=js&"
export * from "./ReaderLayout.vue?vue&type=script&lang=js&"
import style0 from "./ReaderLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports